import { FieldArray, useField } from 'formik'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from 'components/BatchCreateCampaignsModal/BatchCampaigns/CreateBatch/CreateBatch.module.scss'
import { Button } from 'blaze-ui/Button'
import { Plus } from 'blaze-ui/icons'
import { TopicsFieldProps } from 'components/BatchCreateCampaignsModal/BatchCampaigns/Types'

export const TopicsField = ({ numberOfCampaigns }: TopicsFieldProps) => {
  const [field] = useField<string[]>('topics')

  return (
    <label className={Styles.label}>
      <Heading level={4}>What are your campaigns about?</Heading>
      <FieldArray name="topics">
        {({ replace, push, remove }) => (
          <>
            {field.value.map((value, index) => (
              <Input
                key={index}
                name={`topics.${index}`}
                value={value}
                autoFocus
                placeholder="Enter a theme or topic"
                onChange={(e) => replace(index, e.target.value)}
                onBlur={() => {
                  if (index === 0) return

                  if (!value || value.trim().length < 1) {
                    remove(index)
                  }
                }}
              />
            ))}
            <Button
              isDisabled={field.value.length >= numberOfCampaigns}
              frontIcon={Plus}
              variant="ghost-tertiary"
              size="sm"
              onPress={() => push('')}
            >
              New Theme or Topic
            </Button>
          </>
        )}
      </FieldArray>
    </label>
  )
}
